import firebase from "firebase/app";
import "firebase/messaging";

const config = {
  apiKey: "AIzaSyBPcl9ywnUYZ5TXyReRlyw3vNGSprYJQcw",
  authDomain: "oms-learning.firebaseapp.com",
  databaseURL: "https://oms-learning.firebaseio.com",
  projectId: "oms-learning",
  storageBucket: "oms-learning.appspot.com",
  messagingSenderId: "52050315752",
  appId: "1:52050315752:web:b93420cfcdbc15f99efc5d"
};

firebase.initializeApp(config);
const messaging = firebase.messaging();

export const requestFirebaseNotificationPermission = () =>
  new Promise((resolve, reject) => {
    if (Notification.permission === "default") {
      Notification.requestPermission().then(permission => {
        if (permission === "granted") {
          messaging
            .getToken()
            .then(firebaseToken => {
              resolve(firebaseToken);
            })
            .catch(err => {
              console.log(err);
              reject(err);
            });
        } else {
          resolve("");
        }
      });
    } else if (Notification.permission === "granted") {
      messaging
        .getToken()
        .then(firebaseToken => {
          resolve(firebaseToken);
        })
        .catch(err => {
          console.log(err);
          reject(err);
        });
    } else {
      resolve("");
    }
  });

export const onMessageListener = () =>
  new Promise(resolve => {
    messaging.onMessage(payload => {
      console.log(payload);
      resolve(payload);
    });
  });
